import { render, staticRenderFns } from "./superBHotGoods.vue?vue&type=template&id=14234ea2&"
import script from "./superBHotGoods.vue?vue&type=script&lang=js&"
export * from "./superBHotGoods.vue?vue&type=script&lang=js&"
import style0 from "./superBHotGoods.vue?vue&type=style&index=0&id=14234ea2&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports